(function () {
  if (window.__PV_ATTRIBUTION_INIT__) {
    return;
  }
  window.__PV_ATTRIBUTION_INIT__ = true;

  var FIRST_TOUCH_KEY = 'proventus_attribution_first_touch';
  var LAST_PRODUCT_KEY = 'proventus_last_viewed_product';

  var UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var CLICK_ID_PARAMS = ['gclid', 'fbclid', 'msclkid'];

  function safeGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (e) {
      // ignore (private browsing, storage full, etc.)
    }
  }

  function getUrlParams() {
    var params = {};
    var search = window.location.search || '';
    var query = new URLSearchParams(search);
    UTM_PARAMS.concat(CLICK_ID_PARAMS).forEach(function (key) {
      var val = query.get(key);
      if (val) params[key] = val;
    });
    return params;
  }

  function detectDeviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth;
    if (width <= 749) return 'mobile';
    if (width <= 989) return 'tablet';
    return 'desktop';
  }

  // First-touch capture: only ever written once per browser (localStorage),
  // on the very first pageview we see. Never overwritten after that.
  function ensureFirstTouch() {
    var existing = safeGet(localStorage, FIRST_TOUCH_KEY);
    if (existing) return;

    var params = getUrlParams();
    var firstTouch = {
      utm_source: params.utm_source || '',
      utm_medium: params.utm_medium || '',
      utm_campaign: params.utm_campaign || '',
      utm_term: params.utm_term || '',
      utm_content: params.utm_content || '',
      gclid: params.gclid || '',
      fbclid: params.fbclid || '',
      msclkid: params.msclkid || '',
      referrer: document.referrer || '',
      landing_page: window.location.href,
      timestamp: new Date().toISOString(),
    };
    safeSet(localStorage, FIRST_TOUCH_KEY, JSON.stringify(firstTouch));
  }

  function getFirstTouch() {
    var raw = safeGet(localStorage, FIRST_TOUCH_KEY);
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }

  // Tracks the most recently viewed product so the contact form (which lives
  // on its own page, not on product pages) can still report which product a
  // visitor was looking at right before requesting a quote.
  function recordProductView() {
    if (!window.ProventusCurrentProduct) return;
    var data = {
      title: window.ProventusCurrentProduct.title || '',
      handle: window.ProventusCurrentProduct.handle || '',
    };
    safeSet(sessionStorage, LAST_PRODUCT_KEY, JSON.stringify(data));
  }

  function getLastViewedProduct() {
    var raw = safeGet(sessionStorage, LAST_PRODUCT_KEY);
    if (!raw) return { title: '', handle: '' };
    try {
      return JSON.parse(raw);
    } catch (e) {
      return { title: '', handle: '' };
    }
  }

  // Combines current-page UTM/click-id params (so a visitor who clicks a UTM
  // link and converts immediately gets those exact values) with first-touch
  // fallbacks (so a visitor who converts later still has SOME attribution).
  function getAttributionData(extra) {
    var currentParams = getUrlParams();
    var firstTouch = getFirstTouch();
    var lastProduct = getLastViewedProduct();

    var data = {
      form_name: (extra && extra.form_name) || 'contact',
      form_page: window.location.href,
      page_title: document.title,
      product_title: (extra && extra.product_title) || lastProduct.title || '',
      product_handle: (extra && extra.product_handle) || lastProduct.handle || '',
      landing_page: firstTouch.landing_page || window.location.href,
      referrer: document.referrer || '',
      first_referrer: firstTouch.referrer || '',
      utm_source: currentParams.utm_source || firstTouch.utm_source || '',
      utm_medium: currentParams.utm_medium || firstTouch.utm_medium || '',
      utm_campaign: currentParams.utm_campaign || firstTouch.utm_campaign || '',
      utm_term: currentParams.utm_term || firstTouch.utm_term || '',
      utm_content: currentParams.utm_content || firstTouch.utm_content || '',
      gclid: currentParams.gclid || firstTouch.gclid || '',
      fbclid: currentParams.fbclid || firstTouch.fbclid || '',
      msclkid: currentParams.msclkid || firstTouch.msclkid || '',
      device_type: detectDeviceType(),
    };

    return data;
  }

  ensureFirstTouch();
  recordProductView();

  window.ProventusAttribution = {
    getAttributionData: getAttributionData,
  };
})();
